<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.cover}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.cover" v-model="cargoForm.cover" :label="labels.cover" item-text="label" item-value="value" data-vv-name="cover" :data-vv-as="labels.cover" :error-messages="errors.collect('cover')" v-validate="'required'"  @input="doCover" :loading="coverLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.clause}}</h3>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-autocomplete v-model="addClause" v-if="hasAddableClause" :items="addableClause" label="Add Clause" item-text="label" item-value="value" prepend-icon="mdi-playlist-plus" outline @change="doAddClause" clearable></v-autocomplete>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-sm v-if="quoteParam.clauseInit === 1 && cargoForm.clause.length > 0">
          <v-layout row wrap v-for="clause in cargoForm.clause" :key="clause.value" align-center>
            <v-flex xs4>
              <v-subheader>{{ clause.value }}</v-subheader>
            </v-flex>
            <template>
              <v-flex xs6>
                <v-subheader>{{ clause.label }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-tooltip top>
                  <v-btn flat icon color="primary" slot="activator" @click="viewClauseText(clause)">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <span>View Clause Text</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn flat icon color="red" slot="activator" @click="removeClause(clause.value)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <span>Remove Clause</span>
                </v-tooltip>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
        <v-layout row wrap v-else-if="quoteParam.clauseInit === 1 && cargoForm.clause.length <= 0">
          <v-flex xs12>
            No Clause found
          </v-flex>
        </v-layout>
        <loader v-else :height="300" :init="doGetDefClause" loadText="Loading Clause..." errorText="Failed to load Clause" :loading="quoteParam.clauseInit === 0"></loader>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
    <v-dialog v-model="showClauseText" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ selectedClause }} - Clause Text </span>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="showClauseText = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12>
            <v-textarea v-model="selectedClauseText" readonly auto-grow></v-textarea>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { QUOTE_CARGO_PARAM, QUOTE_CARGO_CLAUSE, QUOTE_CARGO_PARAM_CLAUSE, QUOTE_CARGO_PARAM_DEFCLAUSE, QUOTE_CARGO_DEFCLAUSE, AGENCY_QUOTATION_LIFECYCLE } from '@/store/types'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import clone from 'clone'

export default {
  data() {
    return {
      labels: {
        cover: 'Coverage*',
        clause: 'Clause'
      },
      cargoForm: {
        cover: undefined,
        clause: []
      },
      coverLoading: false,
      clauseLoading: false,
      addClause: undefined,
      showClauseText: false,
      selectedClause: '',
      selectedClauseText: ''
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.cargoParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    hasClause() {
      if (this.cargoForm.clause && this.cargoForm.clause.length > 0) {
        return true
      } else {
        return false
      }
    },
    addableClause() {
      let result = []
      if (this.cargoForm.cover) {
        result = this.quoteParam.permittedClause
        if (result && result.length > 0) {
          // Remove those that already exist in local form
          result = result.filter(clause => {
            for (let localClause of this.cargoForm.clause) {
              if (localClause.value === clause.value) {
                return false
              }
            }
            return true
          })
        }
      }
      return result
    },
    hasAddableClause() {
      if (this.addableClause.length > 0) {
        return true
      } else {
        return false
      }
    },
    proceedLoading() {
      if (this.coverLoading || this.clauseLoading) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'quoteParam.clauseInit': function (value) {
      if (value === 1) {
        this.initClause()
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.cargoForm.cover = this.globalForm.cover
      this.cargoForm.clause = this.globalForm.clause
      if (!this.quoteParam.clausesLoaded) {
        this.getCover()
        this.getClause()
        this.$store.commit(QUOTE_CARGO_PARAM_CLAUSE, true)
      }
    },
    async getCover() {
      const apiURI = this.$store.state.agency.quotation.menu.cover
      if (apiURI) {
        try {
          this.coverLoading = true
          const expand = {
            busCls: this.globalForm.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              cover: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
          }
          this.coverLoading = false

          if (this.cargoForm.cover && this.quoteParam.cover && this.quoteParam.cover.length > 0) {
            // Check if the current cover value is still valid
            let coverIsValid = false
            for (var i = 0; i < this.quoteParam.cover.length; i++) {
              const cover = this.quoteParam.cover[i]
              if (cover.value === this.cargoForm.cover) {
                coverIsValid = true
                break
              }
            }
            // Invalid Cover (reset to undefined)
            if (!coverIsValid) {
              this.cargoForm.cover = undefined
              this.$store.commit(QUOTE_CARGO_PARAM_DEFCLAUSE, [])
              this.$store.commit(QUOTE_CARGO_DEFCLAUSE, [])
            } else {
              // Load saved clauses
              this.$store.commit(QUOTE_CARGO_PARAM_DEFCLAUSE, this.globalForm.clause)
            }
          } else {
            // No coverage, clear clauses
            this.$store.commit(QUOTE_CARGO_PARAM_DEFCLAUSE, [])
            this.$store.commit(QUOTE_CARGO_DEFCLAUSE, [])
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.coverLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getClause() {
      const apiURI = this.$store.state.agency.quotation.menu.clause
      if (apiURI) {
        try {
          this.clauseLoading = true
          const expand = {
            busCls: this.globalForm.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              permittedClause: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
          }
          this.clauseLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.clauseLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doCover() {
      this.doGetDefClause()
    },
    initClause() {
      this.cargoForm.clause = []
      if (this.globalForm.clause && this.globalForm.clause.length > 0) {
        this.$set(this.cargoForm, 'clause', clone(this.globalForm.clause))
      }
    },
    doGetDefClause() {
      this.$store.dispatch('cargoQuoteClause', { cover: this.cargoForm.cover })
    },
    removeClause(clause) {
      this.cargoForm.clause.splice(this.cargoForm.clause.indexOf(this.cargoForm.clause.find(x => x.value === clause)), 1)
    },
    doAddClause() {
      if (this.addClause) {
        const clause = this.addableClause.find(x => x.value === this.addClause)
        if (clause) {
          this.cargoForm.clause.push({
            value: clause.value,
            secondaryValue: clause.secondaryValue,
            label: clause.label
          })
        }
        this.addClause = null
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'cargoQuoteShipment' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_CLAUSE, this.cargoForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
          this.$router.push({ name: 'cargoQuoteInsured' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_CARGO_CLAUSE, this.cargoForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    viewClauseText(clause) {
      this.showClauseText = true
      this.selectedClause = clause.value
      this.selectedClauseText = clause.secondaryValue
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
